var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1933_2206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1933_2206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0244 20.05L13.2494 14.3C12.7494 14.7167 12.1744 15.0417 11.5244 15.275C10.8744 15.5083 10.2077 15.625 9.52441 15.625C7.80775 15.625 6.35775 15.0333 5.17441 13.85C3.99108 12.6667 3.39941 11.2167 3.39941 9.5C3.39941 7.8 3.99108 6.354 5.17441 5.162C6.35775 3.97067 7.80775 3.375 9.52441 3.375C11.2244 3.375 12.6661 3.96667 13.8494 5.15C15.0327 6.33333 15.6244 7.78333 15.6244 9.5C15.6244 10.2167 15.5077 10.9 15.2744 11.55C15.0411 12.2 14.7244 12.7667 14.3244 13.25L20.0994 19.025C20.2327 19.1583 20.2994 19.325 20.2994 19.525C20.2994 19.725 20.2244 19.9 20.0744 20.05C19.9244 20.2 19.7454 20.275 19.5374 20.275C19.3287 20.275 19.1577 20.2 19.0244 20.05ZM9.52441 14.125C10.8077 14.125 11.8954 13.675 12.7874 12.775C13.6787 11.875 14.1244 10.7833 14.1244 9.5C14.1244 8.21667 13.6787 7.125 12.7874 6.225C11.8954 5.325 10.8077 4.875 9.52441 4.875C8.22441 4.875 7.12875 5.325 6.23741 6.225C5.34541 7.125 4.89941 8.21667 4.89941 9.5C4.89941 10.7833 5.34541 11.875 6.23741 12.775C7.12875 13.675 8.22441 14.125 9.52441 14.125Z",
    fill: "#B6B6B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.aea0e637ac110487c21f0bda3ddf20f2.svg";
export { ForwardRef as ReactComponent };